"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageAction = exports.imageView = exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  theme,
  cssProps
}) => ({
  backgroundSize: 'contain',
  overflow: 'hidden',
  border: "1px solid ".concat((0, _util.color)(theme, 'ui4')),
  ...cssProps
});

exports.wrapper = wrapper;

const imageView = ({
  cssProps: {
    background,
    ...otherProps
  }
}) => ({
  background: "url(".concat(background, ")"),
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  ...otherProps
});

exports.imageView = imageView;

const imageAction = ({
  theme
}) => ({
  borderRadius: '50%',
  width: 24,
  height: 24,
  background: (0, _util.color)(theme, 'overlay3'),
  cursor: 'pointer'
});

exports.imageAction = imageAction;
//# sourceMappingURL=EventCard.style.js.map